export const TutorifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <path d="M25 10L7 19l18 9 18-9-18-9z" fill="white" opacity="0.95"/>
    <path d="M13 24v9c0 3.3 5.4 6 12 6s12-2.7 12-6v-9L25 30 13 24z" fill="white" opacity="0.7"/>
    <rect x="37" y="19" width="2.5" height="10" rx="1.25" fill="white" opacity="0.9"/>
    <circle cx="38.25" cy="31" r="2" fill="white" opacity="0.9"/>
  </svg>
)

export const ParticifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <circle cx="21" cy="16" r="6" fill="white" opacity="0.9"/>
    <path d="M10 38c0-6 5-11 11-11s11 5 11 11" fill="white" opacity="0.75"/>
    <circle cx="36" cy="34" r="9" fill="white" opacity="0.25" stroke="white" strokeWidth="2"/>
    <path d="M31 34l3.5 4 7-7" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const TrakifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <rect x="9" y="36" width="7" height="6" rx="2" fill="white" opacity="0.5"/>
    <rect x="21" y="28" width="7" height="14" rx="2" fill="white" opacity="0.7"/>
    <rect x="33" y="18" width="7" height="24" rx="2" fill="white" opacity="0.95"/>
    <path d="M10 30l10-8 10-6 10-8" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="10" cy="30" r="2" fill="white"/>
    <circle cx="20" cy="22" r="2" fill="white"/>
    <circle cx="30" cy="16" r="2" fill="white"/>
    <circle cx="40" cy="8" r="2" fill="white"/>
  </svg>
)

export const CalendFyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <rect x="8" y="13" width="34" height="29" rx="5" fill="white" opacity="0.2" stroke="white" strokeWidth="2"/>
    <rect x="8" y="13" width="34" height="11" rx="5" fill="white" opacity="0.45"/>
    <rect x="8" y="20" width="34" height="4" fill="white" opacity="0.35"/>
    <line x1="17" y1="9" x2="17" y2="17" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <line x1="33" y1="9" x2="33" y2="17" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="17" cy="31" r="2" fill="white" opacity="0.9"/>
    <circle cx="25" cy="31" r="2" fill="white" opacity="0.9"/>
    <circle cx="33" cy="31" r="2" fill="white" opacity="0.5"/>
    <circle cx="17" cy="38" r="2" fill="white" opacity="0.5"/>
    <circle cx="25" cy="38" r="2" fill="white" opacity="0.9"/>
  </svg>
)

export const ReportifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <rect x="10" y="8" width="22" height="30" rx="4" fill="white" opacity="0.2" stroke="white" strokeWidth="2"/>
    <line x1="16" y1="17" x2="26" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.9"/>
    <line x1="16" y1="22" x2="26" y2="22" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
    <line x1="16" y1="27" x2="22" y2="27" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    <rect x="30" y="22" width="4" height="16" rx="2" fill="white" opacity="0.95"/>
    <rect x="36" y="28" width="4" height="10" rx="2" fill="white" opacity="0.7"/>
    <rect x="24" y="30" width="4" height="8" rx="2" fill="white" opacity="0.5"/>
  </svg>
)

export const CheckifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <rect x="6" y="14" width="3" height="3" rx="0.8" fill="white" opacity="0.9"/>
    <rect x="6" y="22" width="3" height="3" rx="0.8" fill="white" opacity="0.9"/>
    <rect x="6" y="30" width="3" height="3" rx="0.8" fill="white" opacity="0.9"/>
    <rect x="13" y="13" width="18" height="3" rx="1.5" fill="white" opacity="0.5"/>
    <rect x="13" y="21" width="18" height="3" rx="1.5" fill="white" opacity="0.5"/>
    <rect x="13" y="29" width="13" height="3" rx="1.5" fill="white" opacity="0.5"/>
    <circle cx="35" cy="32" r="9" fill="white" opacity="0.2" stroke="white" strokeWidth="2"/>
    <path d="M30 32l3.5 3.5 6-6" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const NotifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <path d="M25 10c-7.2 0-12 5.4-12 12v8l-3 4h30l-3-4v-8c0-6.6-4.8-12-12-12z" fill="white" opacity="0.85"/>
    <path d="M21 34c0 2.2 1.8 4 4 4s4-1.8 4-4" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
    <circle cx="35" cy="14" r="6" fill="white" opacity="0.95"/>
    <text x="35" y="18" textAnchor="middle" fontSize="8" fontWeight="700" fill="#7aacb3" fontFamily="sans-serif">3</text>
  </svg>
)

export const LogifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <rect x="12" y="9" width="22" height="28" rx="4" fill="white" opacity="0.2" stroke="white" strokeWidth="2"/>
    <line x1="17" y1="18" x2="29" y2="18" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.9"/>
    <line x1="17" y1="23" x2="29" y2="23" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.9"/>
    <line x1="17" y1="28" x2="24" y2="28" stroke="white" strokeWidth="2" strokeLinecap="round" opacity="0.6"/>
    <circle cx="34" cy="35" r="8" fill="white" opacity="0.2" stroke="white" strokeWidth="2"/>
    <circle cx="34" cy="35" r="3.5" fill="white" opacity="0.9"/>
    <line x1="40" y1="41" x2="44" y2="45" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
)

export const ObservifyLogo = ({ size = 88 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
    <rect width="50" height="50" fill="#7aacb3"/>
    <path d="M6 25c5-10 12-15 19-15s14 5 19 15c-5 10-12 15-19 15S11 35 6 25z" fill="white" opacity="0.25" stroke="white" strokeWidth="2.2"/>
    <circle cx="25" cy="25" r="8" fill="white" opacity="0.35" stroke="white" strokeWidth="2"/>
    <circle cx="25" cy="25" r="4" fill="white" opacity="0.95"/>
    <line x1="25" y1="6" x2="25" y2="10" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    <line x1="38" y1="12" x2="35.5" y2="14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    <line x1="12" y1="12" x2="14.5" y2="14.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    <line x1="44" y1="25" x2="40" y2="25" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
    <line x1="6" y1="25" x2="10" y2="25" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
  </svg>
)
